import { EntityService } from '../../../service/EntityService';

export class TenantSettingService extends EntityService {
  static entity = 'app/tenant-setting';
  static getListJob(params): Promise<any> {
    return this.axios.get(`${this.entity}/job-register`, { params }).then((res) => res.data);
  }
  static getTenantJob(params): Promise<any> {
    return this.axios.get(`${this.entity}/tenant-job`, { params }).then((res) => res.data);
  }
  static createJob(data: any): Promise<any> {
    return this.axios.post(`${this.entity}/job`, data).then((res) => res.data);
  }

  static updateJob(data: any): Promise<any> {
    return this.axios.put(`${this.entity}/job`, data).then((res) => res.data);
  }

  static createTenantJob(data: any): Promise<any> {
    return this.axios.post(`${this.entity}/tenant-job`, data).then((res) => res.data);
  }

  static updateTenantJob(data: any): Promise<any> {
    return this.axios.put(`${this.entity}/tenant-job`, data).then((res) => res.data);
  }

  static deleteJob(id: string): Promise<any> {
    return this.axios.delete(`${this.entity}/${id}/job`).then((res) => res.data);
  }

  static deleteTenantJob(id: string): Promise<any> {
    return this.axios.delete(`${this.entity}/${id}/tenant-job`).then((res) => res.data);
  }

  static key = {
    DEFAULT_TY_GIA: 'DEFAULT_TY_GIA',
    DEFAULT_THUE_SUAT_GTGT: 'DEFAULT_THUE_SUAT_GTGT',
    DEFAULT_MA_TIEN_TE: 'DEFAULT_MA_TIEN_TE',
    DEFAULT_KHU_PHI_THUE_QUAN: 'DEFAULT_KHU_PHI_THUE_QUAN',
    DEFAULT_HTTT: 'DEFAULT_HTTT',
    DEFAULT_GIAM_THUE_NQ43: 'DEFAULT_GIAM_THUE_NQ43',
    BAT_LUU_LICH_SU_THAY_DOI_HOA_DON: 'BAT_LUU_LICH_SU_THAY_DOI_HOA_DON',
    DINH_DANG_TIEN_TE: 'DINH_DANG_TIEN_TE',
    THANH_TOAN_QRCODE_HOA_DON: 'THANH_TOAN_QRCODE_HOA_DON',
    TAO_QRCODE_HD_CHO_KY: 'TAO_QRCODE_HD_CHO_KY',
    SINH_SO_SAU: 'SINH_SO_SAU',
    SINH_SO_SAU_MAY_TINH_TIEN: 'SINH_SO_SAU_MAY_TINH_TIEN',
  };
}
